// src/hooks/useCVList.js
import { CVHttpService } from '../services';
import { useQuery } from 'react-query';

function useCVList(params = {}, queryOptions = {}) {
  const { data, isLoading, error } = useQuery(
    ['cvList', params], 
    () => CVHttpService.loadCVList(params),
    queryOptions
  );
  return { data, isLoading, error };
}

export default useCVList;
